/* global _ */
/* global dataLayer */
/* global Blob */
const Color = require('color');
import cssVars from 'css-vars-ponyfill';
import router from '../router';
import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import admin from './admin.js';
import canvas from './canvas.js';
import instructors from './instructors.js';
import learners from './learners.js';
import moment from 'moment';
import storejs from 'store';
import {
  dynamicPHPPath,
  getServerUrl
} from '@utilities';

import {
  PLAYPOSIT_API_ENDPOINTS,
  LTI_CONTENT_LINKED_STATUSES,
  LTI13_MIGRATION_STATUSES,
  LTI_RENDER_PATHS,
} from '@Constants';

import _ from 'lodash';

console.log('INFO:: PHP Referer:'+dynamicPHPPath(window.location.hostname));

Vue.use(Vuex);

const store = new Vuex.Store({
   modules: {
     admin,
     canvas,
     instructors,
     learners
   },

   state: {
    //global app state
    serverURL: '',
    urlToken: '',
    nodeApiPrefix:  (process.env.NODE_ENV === 'production') ? '' : process.env.API_URL,
    playerApiPrefix:  (process.env.NODE_ENV === 'production') ? '' : process.env.API_URL,
    designerApiPrefix:  (process.env.NODE_ENV === 'production') ? '' : process.env.API_URL,
    shareNodeApiPrefix:  (process.env.NODE_ENV === 'production') ? window.location.origin : ( process.env.API_URL ? process.env.API_URL : '' ),
    phpApiPrefix: dynamicPHPPath(window.location.hostname),

    //permision toggles
    adminPermission: false,
    superAdminPermission: false,
    instructorPermission: false,
    learnerPermission: false,
    primaryAccount: null,
    LTIlaunch: false,
    passbackLinking: false,

    //instructor type
    instructorType: '',
    
    dashLoading: true, 

    //simple dash toggle
    simpleDash: false,
    simpleDashType: null,
    simpleDashData: {},
    simpleDashLoading: false,
    simpleDashReload: false,

    // updated bluescreen
    bluescreenData: {},
    greyscreen: null,

    //tokenData
    username: '',
    userImg: null,
    adminData: {
      type: '',
      renewalDate: '',
      storageMin: 0,
      manager: '',
      managerEmail: '',
      hosting: false,
      usageStartDate: null
    },
    instructorData: {
      token: null,
      email: null,
      id: null,
      firstName: null,
      lastName: null,
      timezone: null,
      timezoneAbr: null,
      timezoneCurrent: null,
    },
    learnerData: {
      token: null,
      email: null,
      id: null,
      firstName: null,
      lastName: null,
      timezone: null,
      avatarInitials: '',
    },
    legacy: {
      legacy: false,
      importedLessons: false,
      showImportWarning: false,
      importedUnits: false,
    },
    school: {
      id: null,
      name: null,
      logo: '',
      active_color: '#2196F3',
      inactive_color: '#1976d2',
      base_color: '#fff',
      darkerHex: '#0c88eb',
      lighterHex: '#37a0f4',
      canvasToken: false,
      LTI: [],
      district_schools:'',
      master_district: null,
      hideOrganizationToggle: false,
      config: {},
      idp_url: null,
    },
    pro: {
      expiration: '',
      hosting_purchased: 0,
    },
    free: {
      ba_limit: 0,
      driftOff: false,
    },

    //LTI data
    LTIdata: {
      contentId: null, // bulbId or playlistId
      contentName: null, // bulb.name or playlist.name
      ContentItem: "",
      contentSectionId: "", // bulb.bulbSection.id for broadcast or playlist.sectionId for monitor
      consumer_pk: "",
      consumerVersion: '',
      context_id: "",
      disable_placement: "",
      enable_grading: "",
      launch_endpoint: "",
      lti_user: "",
      message_type: "",
      resource_data_teacher_id: "",
      section_id: "", // playposit section.id of LMS course
      consumer_key:"", // LTI consumer tool key
      render_path: "", // play2, learnermade2, broadcast2, playlist
      isContentItemLaunch:"", // is this launch a CIM picker launch
      resource_link_id: "",
      insert_stuff: "",
      previouslyLinked: {
        loaded: false,
        linked: false,
        data: {}
      },
      contentMigrated: false,
    },
    LMSdata: {
      type: '',
      img: '',
    },
    LTILogs: [],
    ltiSync: {
      toggle: false,
      alert: false,
      msg: ''
    },
    LTIclassName: '',
    LTIajaxing: false,
    lti13Launch: false,
    LTIPlacement: null,
    ltiContentMigrationFinished: false,
    isRouterView: false,

    //state for nav
    routerView: 'dashboard',
    activeView: 'Dashboard',
    breadcrumbs: [
      {text:'Dashboard',payload: ''}
    ],
    breadcrumbPayloads: {
      'Classes': {
          activeView: 'Classes',
          activeViewRoute: 'Classes',
          breadcrumb: [{
              text: 'Classes',
              payload: '',
          }],
          queryParams: {},
          route: 'instructor',
      },
      'My-Bulbs': {
          activeView: 'My-Bulbs',
          activeViewRoute: 'My-Bulbs',
          breadcrumb: [{
              text: 'My Bulbs',
              payload: '',
          }],
          queryParams: {},
          route: 'instructor',
      },
      'Schools': {
          activeView: 'Administration',
          activeViewRoute: 'Schools',
          breadcrumb: [{
              text: 'Administration',
              payload: '',
          }],
          queryParams: {},
          route: 'admin',
      },
      'Playlists': {
          activeView: 'Playlists',
          activeViewRoute: 'Playlists',
          breadcrumb: [{
              text: 'Playlists',
              payload: '',
          }],
          queryParams: {},
          route: 'instructor',
      },
  },

    //boolean checks for data loading
    userDataLoaded: false,
    triggerRefresh: false,
    stateDataLoaded: false,
    popoverDataLoading: false,

    //boolean checks for component loading
    snackbar: {
      show: false,
      text: '',
      textColor: '',
      color: null,
      timeout: 6000,
      action: '',
      action_text: '',
      customClass: '',
    },
    slideOut: {
      nameMenu: false,
    },
    slideOutLarge: {
        toggle: false,
        view: null,
        data: {},
    },
    dashModal: null, 
    dialogShow: {
      dash: false,
      data: {},
    },
    popoverToggles: {
      bulbAnalytics: false,
      coursePermission: false,
      filterMenu: false,
      filterMenuInteraction: false,
      filterMenuPlaylist: false,
      exportMenu: false,
      graphMenu: false,
      addMenu: false,
      moveMenu: false,
      editMenu: false,
      copyMenu: false,
      shareMenu: false,
      assignMenu: false,
      joinClass: false,
      profile: false,
      monitor: false,
      remove: false,
      preview: false,
      export: false,
      bulbInfo: false,
      importStatus: false,
      mobileWarning: false,
      lti: false,
      ltiSync: false,
      addVideo: false,
      confirm: false,
      interaction: false,
      lmb: false,
      lmbEdit: false,
      lmbRubric: false,
      shareLearner: false,
      addSchool: false,
      editSchool: false,
      addInstructors: false,
      editInstructors: false,
      groups: false,
      adminFilterMenu: false,
      snapshot: false,
      broadcast: false,
      addFolder: false,
      editFolder: false,
      addToFolder: false,
      copyFolder: false,
      shareFolder: false,
      copyClassicBulbs: false,
      addNodeFolder: false,
      editNodeFolder:false
    },
    //peer review
    rubric_lmb_data: {},
    rubric_options: {},
    searchingForTags: false,
    helpScout:'!function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});window.Beacon("init", "bc56f842-2a1b-4ea3-90cc-ecc77f53078e");',
    viewedComments: [],
    userAgent: {},
    permittedProquestPaths: [],
  },

  mutations: {
    //mutations to set user, school data, and branding
    setDashLoading(state, val) {
      state.dashLoading = val;
    },
    //set token from url
    setToken(state, token) {
      //grabs token from url and sets to state
      state.urlToken = token;
    },
    setUserData(state, tokenData) {
      //sets permissions
      state.adminPermission = tokenData.permissions.admin;
      state.superAdminPermission = tokenData.permissions.superAdmin;
      state.instructorPermission = tokenData.permissions.instructor;
      state.learnerPermission = tokenData.permissions.learner;
      state.primaryAccount = tokenData.permissions.primary;

      //set adminData
      state.adminData = tokenData.adminData;
      //set primary account data
      if(state.primaryAccount !== 'Learner') {
        //if no learner (admin or instructor)
        //set username and image
        state.username = tokenData.instructorData.teacherName;
        state.userImg = tokenData.instructorData.picture;

        //set instructorType
        state.instructorType = tokenData.instructorData.type;

        //set other instructorData
        state.instructorData.id = tokenData.instructorData.id;
        state.instructorData.token = tokenData.instructorData.token;
        state.instructorData.email = tokenData.instructorData.email;
        state.instructorData.firstName = tokenData.instructorData.firstName;
        state.instructorData.lastName = tokenData.instructorData.lastName;
        state.instructorData.isAdmin = tokenData.instructorData.isAdmin,
        state.instructorData.migrated = tokenData.instructorData.migrated,

        //sets token to state
        storejs.set('pp_instructor_token', tokenData.instructorData.token);
        storejs.set('pp_primary', 'instructor');

        //set timezone data from user_info
        let tz = moment.tz.guess();
        if(tokenData.instructorData.user_info && tokenData.instructorData.user_info.time_zone){
          state.instructorData.timezone = tokenData.instructorData.user_info.time_zone;
          state.instructorData.timezoneAbr = moment.tz(tokenData.instructorData.user_info.time_zone).format('z');
        } else {
          state.instructorData.timezone = tz;
          state.instructorData.timezoneAbr = moment.tz(tz).format('z');
        }
        //set timezone from browser
        state.instructorData.timezoneCurrent = moment.tz(tz).format('z');

        //set school data
        if(tokenData.instructorData.type === 'institutionLTI' || tokenData.instructorData.type === 'institutionNonLTI'){
          state.school.id = tokenData.school.id;
          state.school.name = tokenData.school.name;
          state.school.listed = tokenData.school.listed;
          state.school.logo = tokenData.school.logo;
          state.school.LTI = tokenData.school.ltiIntegrations;
          state.school.district_schools = tokenData.school.district_schools;
          state.school.master_district = tokenData.school.master_district;
          state.school.canvasApi = tokenData.school.canvasApi;
          state.school.config = tokenData.school.config || {};
          state.school.collaboration_district_ids = tokenData.school.collaboration_district_ids;
          state.school.childSchoolIds = tokenData.school.childSchoolIds;
          state.school.permissionKeys = tokenData.school.permissionKeys;
          state.school.idp_url = tokenData.school.idp_url;
          state.school.cssInjection = tokenData.school.cssInjection;
          //if only one school in district, hide my community organization toggle
          if (tokenData.school.district_schools.split(',').length === 1 && tokenData.school.collaboration_district_ids.length === 0) {
            state.school.hideOrganizationToggle = true;
          }
        }

        //set legacy data
        state.legacy.legacy = tokenData.legacy.legacy;
        state.legacy.importedLessons = tokenData.legacy.importedLessons;
        state.legacy.showImportWarning = tokenData.legacy.importLessonError;
        state.legacy.importedUnits = tokenData.legacy.importedUnits;

        //set learnerData if available
        if(Object.keys(tokenData.learnerData).length > 0){
          state.learnerData.id = tokenData.learnerData.id;
          state.learnerData.email = tokenData.learnerData.email;
          state.learnerData.token = tokenData.learnerData.token;
          state.learnerData.firstName = tokenData.learnerData.firstName;
          state.learnerData.lastName = tokenData.learnerData.lastName;
          state.learnerData.migrated = tokenData.learnerData.migrated;

          //set initial learner breadcrumb payload with learner's name
          state.breadcrumbPayloads['Learner'] = {activeView: 'Learner', activeViewRoute: 'Learner', breadcrumb:[{text:`${tokenData.learnerData.firstName}'s Classes`, payload: ''}], query_params: {}, route:'learner'},

          //sets token to state
          storejs.set('pp_learner_token', tokenData.learnerData.token);
        } else {
          //if no learner account remove existing instructor tokens
          storejs.remove('pp_learner_token');
        }

        //add pro data
        if(tokenData.instructorData.type === 'pro'){
          state.pro.hosting_purchased = tokenData.pro.hosting_purchased;
          state.pro.expiration = tokenData.pro.expiration;
        }

        //add free data
        if(tokenData.instructorData.type === 'free'){
          state.free.ba_limit = tokenData.free.baLimit;
          state.free.driftOff = tokenData.free.driftOff;
        }
        var url = new URL(window.location);
        var params = new URLSearchParams(url.search);
        // if embed = true - don't load helpScout widget
        if (!params.get('embed') && !params.get('routerView')) {
          //add helpscout widget
          const help = document.createElement('script');
          help.innerHTML = state.helpScout;
          document.body.appendChild(help);
        }

      } else {
        //if learner
        state.username = tokenData.learnerData.studentName;

        //set learnerData
        state.learnerData.id = tokenData.learnerData.id;
        state.learnerData.email = tokenData.learnerData.email;
        state.learnerData.token = tokenData.learnerData.token;
        state.learnerData.firstName = tokenData.learnerData.firstName;
        state.learnerData.lastName = tokenData.learnerData.lastName;
        state.learnerData.timezone = moment.tz.guess();
        state.learnerData.avatarInitials = `${tokenData.learnerData.firstName[0]} ${tokenData.learnerData.lastName[0]}`;
        state.learnerData.isProquestStudent = tokenData.learnerData.isProquestStudent;
        state.learnerData.migrated = tokenData.learnerData.migrated;

        //set initial learner breadcrumb payload with learner's name
        state.breadcrumbPayloads['Learner'] = {activeView: 'Learner', activeViewRoute: 'Learner', breadcrumb:[{text:`${tokenData.learnerData.firstName}'s Classes`, payload: ''}], query_params: {}, route:'learner'},


        //sets token to state
        storejs.set('pp_learner_token', tokenData.learnerData.token);
        storejs.set('pp_primary', 'learner');

        //checks if student account is archived and shows student activate screen
        if(tokenData.learnerData.archived){
          state.simpleDash = true;
          state.simpleDashType = 'studentactivate';
        }


        //set instructorData if available
        if(Object.keys(tokenData.instructorData).length > 0){
          state.instructorData.id = tokenData.instructorData.id;
          state.instructorData.token = tokenData.instructorData.token;
          state.instructorData.email = tokenData.instructorData.email;
          state.instructorData.firstName = tokenData.instructorData.firstName;
          state.instructorData.lastName = tokenData.instructorData.lastName;

          //sets token to state
          storejs.set('pp_instructor_token', tokenData.instructorData.token);
        } else {
          //if no instructor account remove existing instructor tokens
          storejs.remove('pp_instructor_token');
        }
      }

      //set branding and create css variables
      if (
        (
          state.instructorType === 'institutionLTI'
          || state.instructorType === 'institutionNonLTI'
        )
        || (
          state.primaryAccount === 'Learner'
          && !!state?.learnerData?.id
          && !!tokenData?.school
        )
      ) {
        if (tokenData.school.active_color) state.school.active_color = tokenData.school.active_color;
        if (tokenData.school.base_color) state.school.base_color = tokenData.school.base_color;
        if (tokenData.school.inactive_color) state.school.inactive_color = tokenData.school.inactive_color;

        let darkerHex = Color(state.school.active_color).darken(0.15).hex();
        state.school.darkerHex = darkerHex;
        let lighterHex = Color(state.school.active_color).lighten(0.15).hex();
        state.school.lighterHex = lighterHex;
      }

      //set colors to css vars
      let cssVarsObj = {
        'branding-active-hex': state.school.active_color,
        'darkerHex': state.school.darkerHex,
        'lighterHex': state.school.lighterHex
      };
      cssVars({variables: cssVarsObj});

      //create css global variable with default
      let str = `body{ --branding-active-hex: ${state.school.active_color} ; --darkerHex: ${state.school.darkerHex} ; --lighterHex: ${state.school.lighterHex}}`;
      const node = document.createElement('style');
      node.innerHTML = str;
      document.body.appendChild(node);

      //toggle data is set
      state.userDataLoaded = true;
    },
    setTeacherData(state, obj){
      state.instructorData.id = obj.id;
      state.instructorData.token = obj.token;
    },
    updateUnitImport(state, obj){
      state.legacy.importedUnits = true;
    },

    //mutations to control data loading
    stateDataLoadedToggle(state){
      state.stateDataLoaded = true;
    },
    setPopoverDataLoading(state, boolean){
      state.popoverDataLoading = boolean;
    },
    setBluescreenData(state, props) {
      state.bluescreenData = props;  
    },
    setGreyscreen(state, props) {
      if (props === null || props === undefined) {
        state.greyscreen = null;
      } else {
        state.greyscreen = props;
      }
      state.dashLoading = false;
    },
    //Mutations for Nav

    //controls activeView and routerView
    setIsRouterView(state, val) {
      state.isRouterView = val;
    },
    setNav(state, array){
      // [ ] refactor to pass an object with {activeView, routerView}
      state.activeView = array[0];
      state.routerView = array[1];
    },
    // controls badge for feedback notifications
    setViewedComments(state, commentId) {
      state.viewedComments.push(commentId);
    },
    //control breadcrumbs
    updateBreadCrumbs(state, array){
      // [ ] refactor to pass object with {breadcrumb, payload}
      let breadcrumb = array[0];
      let payload = array[1];

      state.breadcrumbs = breadcrumb;
      state.breadcrumbPayloads = Object.assign(state.breadcrumbPayloads, payload);
    },
    resetBreadcrumbHistory(state){
      state.breadcrumbHistory = [];
    },

    //Toggle on Dialogs/Slide Out/Snack Bar/Simple Dash/Tutorials
    triggerMobileWarning(state){
      state.dialogShow.dash = true;
      state.popoverToggles.mobileWarning = true;
    },
    handleDialogOpen(state, obj){
      state.popoverToggles[obj.type] ? state.popoverToggles[obj.type]  = false : state.popoverToggles[obj.type]  = true;
      state.dialogShow.data = obj.data;
      state.dialogShow.dash = true;
    },
    setDashModal(state, obj) {
      // reset the other modal to off
      _.map(state.popoverToggles, (value, modal) => {
        state.popoverToggles[modal] = false;
      });
      state.dialogShow.dash = !!obj; // backwards compatibiliy
      state.dashModal = obj;
    },
    dashModalSwap(state, obj) {
      if (obj.popover) {
        // swap back to popover 
        state.popoverToggles[obj.popover] = true;
        // turn off dashModal
        state.dashModal = null;
      } 
      // figure out how to swap between dashModals
    },
    //mutations to control component toggling
    slideOut(state, obj) {
      state.slideOutLarge = obj;
    },
    triggerSnackbar(state, data) {
      // triggers snackbar warning, sets text and color, and resets it after 6 sec
      state.snackbar.show = true;
      state.snackbar.text = data.text;
      state.snackbar.textColor = (data.color === 'warning') ? 'black' : data?.textColor || 'white',
      state.snackbar.color = data.color;
      state.snackbar.timeout = data.timeout;
      state.snackbar.aria_live = data.aria_live;
      state.snackbar.customClass = data?.customClass || '';

      if (data.action) {
        state.snackbar.action = data.action;
        state.snackbar.action_text = _.get(data, 'action_text', _.get(data, 'actionText'));
        state.snackbar.actionData = data.actionData;
      }
      if (data.timeout != 0) {
          setTimeout(() => {
          state.snackbar.show = false;
          state.snackbar.text = '';
          state.snackbar.color = null;
        }, data.timeout);
      }
    },
    simpleDashToggle(state, obj) {
      if (obj.activate) {
        state.simpleDash = true;
        state.simpleDashType = obj.type;
        state.simpleDashData = obj.data;
      } else {
        state.simpleDash = false;
        state.simpleDashType = null;
        state.simpleDashData = {};
      }
      state.dashLoading = false;
    },
    simpleDashReloadToggle(state, boolean){
      state.simpleDashReload = boolean;
    },


    //LTI Mutations
    setLTIuser(state, data) {
      state.LTIlaunch = true;
      state.LTIdata = {
        contentId: null, 
        ContentItem: data.ContentItem,
        contentName: data.content_name || data.contentName,
        consumer_pk: data.consumer_pk,
        consumerVersion: data?.consumerVersion || '',
        deploymentId: data?.deploymentId,
        lti1p1ResourceLinkId: data?.lti1p1ResourceLinkId,
        context_id: data.context_id,
        disable_placement: data.disable_placement,
        enable_grading: Array.isArray(data?.enable_grading?.data) ? data?.enable_grading?.data?.[0] :  data.enable_grading,
        launch_endpoint: data.launch_endpoint,
        lti_user: data.lti_user,
        message_type: data.message_type,
        resource_data_teacher_id: data.resource_data_teacher_id,
        section_id: data.section_id,
        sectionName: data.LTIclassName,
        contentSectionId: data.content_section_id || data.contentSectionId, // used for broadcast, playlist monitor
        consumer_key: data.consumer_key,
        render_path: data.render_path,
        isContentItemLaunch: data.isContentItemLaunch,
        resource_link_id: (data.resource_link_id || data?.resourceLinkId),
        previouslyLinked: {
          loaded: false,
          linked: false,
          data: {}
        },
        peer_review: data.peer_review === "true" ? true : false,
        groupSetId: data.groupSetId,
        insert_stuff: data.insert_stuff,
        contentMigrated: (!!data?.contentMigrated?.data?.[0]) || false,
        issuer: data?.issuer,
      }
      
      if (data.content_id) {
        state.LTIdata.contentId = parseInt(data.content_id, 10);
      }
      else if (data.contentId) {
        state.LTIdata.contentId = parseInt(data.contentId, 10);
      }
      if (data.LTIclassName) state.LTIclassName = data.LTIclassName;
      // store data in local storage for browser refresh of lti launch
      storejs.remove('lti');
      storejs.set('lti', state.LTIdata);
    },
    setLti13Launch(state, value) {
      state.lti13Launch = value;
    },
    setLTIPlacement(state, placement) {
      state.LTIPlacement = placement;
    },
    setLtiContentMigrationFinished(state, value) {
      state.ltiContentMigrationFinished = value;
    },
    setLMS(state, data){
      //set LMS type, groupImport, and image
      state.LMSdata = data; // triggered from getLmsData action
    },
    setLinkCheck(state, data){
      state.LTIdata.previouslyLinked.loaded = true;
      state.LTIdata.previouslyLinked.linked = data.linked;
      state.LTIdata.previouslyLinked.data = data.data;
    },
    resetLinkCheck(state){
      state.LTIdata.previouslyLinked.loaded = false;
      state.LTIdata.previouslyLinked.linked = false;
      state.LTIdata.previouslyLinked.data = {};
    },
    setContentData(state, data) {
      state.LTIdata.render_path      = data.lesson_url;
      state.LTIdata.contentId        = data.default_lesson_id;
      state.LTIdata.contentName      = data.playpositContentName;
      state.LTIdata.consumer_key     = (!state?.lti13Launch) ? data.consumer_key256 : data.client_id
      state.LTIdata.resourceLinkName = (!state?.lti13Launch) ? data.resource_link_title : data.context_resource_link_title;
      state.LTIdata.bulbTags         = data.bulbTags;
      state.LTIdata.peer_review      = data.peer_review;
      state.LTIdata.enable_grading   = data.enable_grading;
      state.LTIdata.contentMigrated  = (!!data?.contentMigrated?.data?.[0]) || false;

      if (data.section_name) {
        state.LTIdata.sectionName = data.section_name;
        state.LTIclassName = data.section_name;
      }
      state.LTIdata.groupSetId = data.group_set_id; 

      if (data.nonPicker) {
        state.dialogShow.dash = false;
        state.popoverToggles.lti = false;
      }

      
      if (data.section_name) state.LTIclassName = data.section_name;
      
      // Yup! This is *very* necessary for LTI to work...
      storejs.set('lti', state.LTIdata);
      
      if (!data.monitor) {
        //if data set, go to manage simple dash, if not, go to link simple dash
        if (data.default_lesson_id != null) {
          //create message based if LTIclassName already defined or not
          let msg;
          if (_.get(state, 'LTIdata.sectionName')) {
            msg = `"${data.playpositContentName}" assigned to "${state.LTIclassName}"`
          } else {
            msg = `"${data.playpositContentName}" `
          }
          
          if (
            _.get(state, 'school.config.permissions', []).includes('hasNewGreyscreen')
            && data.lesson_url === LTI_RENDER_PATHS.Play2
          ) {
            if (state.simpleDash) {
              state.simpleDash = false;
              state.simpleDashType = false;
              state.simpleDashData = {}
            }
            state.dashLoading = false;
            state.greyscreen = { view: 'lti' };
          }
          else {
            state.simpleDash = true;
            state.simpleDashType = 'lti';
            state.simpleDashData = {
              title:'Manage Link', 
              msg, 
              primary:'Monitor', 
              primarylink:'monitor', 
              primaryicon:'launch', 
              secondary:'Preview', 
              secondarylink:'preview', 
              tertiary:'CSV Download', 
              tertiarylink:'csvDownload', 
              exit:'myBulbs',
              exitText:'Enter PlayPosit' 
            }
          }
        } else {
          state.simpleDashType = 'lti';
          state.simpleDashData = {
            title:'Set Link',
            msg:'No content has been attached to this link',
            secondary:'Learn More', 
            secondarylink:'learnMore', 
            primary:'setLink',
            primarylink:'exit',
            exit:'exit',
            exitText:'Enter PlayPosit'
          }
          state.simpleDash = true;
        }
      }
    },
    setLogData(state, data){
      data.map(item => {
        if(item.timestamp) item.timestamp = moment.tz(item.timestamp, state.instructorData.timezone).format('MMM DD, YYYY hh:mm A');
      })
      state.LTILogs = data;
    },
    setLtiSync(state, msg){
      state.ltiSync.toggle = false;
      if(msg){
        state.ltiSync.alert = true;
        state.ltiSync.msg = msg;
      } else {
        state.ltiSync.alert = false;
        state.ltiSync.msg = '';
      }
    },
    resetLTIPopover(state, data){
      state.LTIdata.previouslyLinked.linked = false;
      state.dialogShow.dash = false;
      state.popoverToggles.lti = false;
      if (data.reset) {
        state.dialogShow.data = data.data;
      }
      state.dialogShow.dash = true;
      state.popoverToggles.lti = true;
    },
    //Mutations for LMB
    closeLMB(state){
      //close lmb modal
      state.dialogShow.dash = false;
      state.popoverToggles.lmb = false;
    },
    setLMB(state, data){
      //close lmb modal
      state.dialogShow.dash = false;
      state.popoverToggles.lmb = false;
      //add data to assign modal and open it
      Vue.nextTick(() => {
        data.data.lmb_id = 1;
        state.dialogShow.data = data.data;
        state.popoverToggles.assignMenu = true;
        state.dialogShow.dash = true;
      })
    },
    setLMBlti(state, data){
      //close lmb modal
      state.dialogShow.dash = false;
      state.popoverToggles.lmb = false;
      //add data to assign modal and open it
      Vue.nextTick(() => {
        data.data.lmb_id = 1;
        state.dialogShow.data = data.data;
        state.popoverToggles.lti = true;
        state.dialogShow.dash = true;
      })
    },
    setLMBrubric(state, data){
      //close lmb modal
      if(data.edit){
        state.dialogShow.dash = false;
        state.popoverToggles.lmbEdit = false;
      } else{
        state.dialogShow.dash = false;
        state.popoverToggles.lmb = false;
      }

      state.rubric_options = {
        interactions: data.data.interactions.rubricInteraction,
        startTime: 0,
        token: state.instructorData.token,
        bulbId: data.data.id,
        apiUrl: (process.env.NODE_ENV === 'production') ? '/' : process.env.API_URL,
        activeHex: state.school.active_color,
        baseHex: '#FFF',
        inactiveHex: state.school.darkerHex,
        edit:false
      }
      if(data.edit){
        state.rubric_options.edit = true;
      }

      if(!data.edit){
        //open up lmbRubric
        Vue.nextTick(() => {
          data.data.lmb_id = 1;
          state.rubric_lmb_data = data.data;
          state.popoverToggles.lmbRubric = true;
          state.dialogShow.dash = true;
        })
      }
    },
    rubricNext(state){
      state.slideOutLarge = {
        toggle:false,
        view: null
      }
      state.dialogShow.dash = false;
      state.popoverToggles.lmbRubric = false;

      if(state.LTIlaunch){
        //open up link
        Vue.nextTick(() => {
          state.dialogShow.data = state.rubric_lmb_data;
          state.popoverToggles.lti = true;
          state.dialogShow.dash = true;
        })
      }
    },
    saveRubricInteractions(state, interactions){
      state.rubric_options.interactions = interactions;
    },

    //Mutations for learner
    setNewColor(state, color){
      state.school.active_color = color;
      let darkerHex = Color(color).darken(0.15).hex();
      state.school.darkerHex = darkerHex;

      let lighterHex = Color(color).lighten(0.15).hex();
      state.school.lighterHex = lighterHex;


      //create css global variable with branding
      let str = `body{ --branding-active-hex: ${color} ; --darkerHex: ${darkerHex} ; --lighterHex: ${lighterHex}}`;
      const node = document.createElement('style');
      node.innerHTML = str;
      document.body.appendChild(node);
    },
    setLearnerData(state, data){
      state.learnerData.token = data.token;
      state.learnerData.email = data.email;
      state.learnerData.id = data.id;
    },
    updateServerURL(state, serverURL) {
      state.serverURL = serverURL;
    },
    setSearchingForTags: (state, value) => {
      state.searchingForTags = value;
    },
    setPassbackLinking: (state, value) => {
      state.passbackLinking = value;
    },
    setUserAgent: (state, value) => {
      state.userAgent = value;
    },
    updatePermittedProquestPaths(state, permittedProquestPaths = []) {
      state.permittedProquestPaths = permittedProquestPaths;
    },
    updateUserProfilePicture(state, profilePicture) {
      state.userImg = profilePicture;
    },
  },
  
  actions: {
    getServerUrl: ({commit}) => {
      try {
        const serverURL = getServerUrl();
        commit('updateServerURL', serverURL);
        return serverURL;
      } catch(e) {
        commit('updateServerURL', '/');
        return '/';
      }
    },
    updateUrl: ({state}) => {
      // updates the url on changes to table including activeView and all query params
      if(state.primaryAccount === 'Instructor') {
        router.push({name: 'dashboard',
        params:{activeView:state.username},
        query:{
            token: state.instructorData.token}});
      } else {
        router.push({name: 'dashboard',
        params:{activeView:state.username},
        query:{
            token: state.studentData.token}});
      }
    },
    async sendProquestData({ state }, {
      id,
      type,
      event,
      skipCallback = false,
    } = {}) {
      const { data } = await axios.post(`${state.nodeApiPrefix}/proquest/data/${type}/${id}/${event}?skipCallback=${skipCallback}`, null, {
        headers: {
          Authorization: `Bearer ${state.instructorData.token}`,
        },
      });
      if (
        data?.id
        && window.self !== window.top
      ) {
        window.parent.postMessage(JSON.stringify({
          type,
          event,
          data,
        }), '*');
      }
      return data;
    },
    getUserData: async ({commit, state}) => {
     //data call for user data
     await axios.get(`${state.nodeApiPrefix}/authnew/users?token=${state.urlToken}`)
      .then(res => {
        if(res.status === 200){
          commit('setUserData', res.data.data);
          if (
            res.data.data.instructorData.migrated
            || res.data.data.learnerData.migrated
          ) {
            commit('setDashModal', { type: 'migrationNotice' });
          }
          if (
            res.data.data.permissions.primary === 'Instructor'
            && res.data.data.instructorData.type === 'free'
            && res.data.data.free.ba_limit == 100
          ) {
            //if free user has reached 100 bulb attempts
            commit('triggerSnackbar', {
              text: "You have reached your monthly limit for learner attempts",
              color: 'red',
              action: 'upgrade',
              action_text: 'Upgrade',
              timeout: 0,
            });
          }
        }
      }).catch((err) => {
        dataLayer.axiosLog(err);
         //create bluescreen simpledash
        commit('setBluescreenData', {
          title: 'Unauthorized',
          icon: 'info',
          text: 'User not found or is archived. Please contact help@playposit.org for support',
          buttons: [ { action: 'help' } ]
        }, { root: true });
        console.error(err);
      });
    },
    getLmsData: async ({ commit, dispatch, getters, state }, data) => {
      // get lms data related to this specific teacher
      try {
        const {
          nodeApiPrefix,
          urlToken: userToken,
        } = state;
        const {
          ltiLaunchPath,
        } = getters;
        const {
          consumerPk,
          sectionId,
        } = data;
        const result = await axios.get(
          PLAYPOSIT_API_ENDPOINTS.getLmsData({
            nodeApiPrefix,
            ltiLaunchPath,
            consumerPk,
            sectionId,
            lodashInstance: _,
          }),
          {
            headers: {
              'Authorization':`Bearer ${userToken}`,
            },
          }
        );
        const {
          data: lmsData,
        } = result;
        commit('setLMS', lmsData);
      } catch (error) {
        dataLayer.errorLog(error.response);
        console.error(error);
      }
    },
    getContent: async ({ commit, getters, state }, obj) => {
      // gets the data for lti launch of this specific attempt
      try {

        const {
          nodeApiPrefix,
          instructorData: {
            token: instructorToken,
          }
        } = state;
        const {
          ltiLaunchPath,
        } = getters;
        const {
          resource_link_id: resourceLinkId,
          consumer_pk: consumerPk,
          token: userToken,
        } = obj;
        const deploymentId = obj?.deploymentId;

        const res = await axios.get(
          PLAYPOSIT_API_ENDPOINTS.getContent({
            nodeApiPrefix,
            ltiLaunchPath,
            resourceLinkId,
            consumerPk,
            deploymentId,
            lodashInstance: _,
          }),
          {
            headers: {
              'Authorization':`Bearer ${userToken}`,
            },
          }
        );

        if (obj?.monitor) res.data.data['monitor'] = true;

        if (!res.data.exists) {
          //no lti resource link- needs to set bulb
          let data = {
            title:'Set Link', 
            msg:'No content has been attached to this link',
            secondary:'Learn More',
            secondarylink:'learnMore', 
            primary:'setLink', 
            primarylink:'exit', 
            exit:'myBulbs', 
            exitText:'Enter PlayPosit'
          }
          commit('simpleDashToggle', {
            activate: true,
            type: 'lti',
            data,
          });
        } else if (
          res.data.exists === true
          && res.data.migrated == true
        ) {
          //data exists and migrated - may be assigned or not assigned yet (handled in setContentData)
          const ltiData = res.data.data
          if (
            _.get(state, 'school.config.permissions', []).includes('hasNewGreyscreen')
            && res.data.data.lesson_url === LTI_RENDER_PATHS.Play2
          ) {
            // get additional data before setting the LTI content data
            // get bulb Tags
            const {
              data,
            } = await axios.get(`${nodeApiPrefix}/instructor/bulbs/${_.get(ltiData, 'default_lesson_id')}/tags`,
            {
              headers: {
                'Authorization':`Bearer ${instructorToken}`,
              }
            });
            // get bulb Folder location
            ltiData.bulbTags = _.map(data, 'text').join(', ').trim();
          }
          commit('setContentData', ltiData);
        }
        // TODO TAM clean: I could possibly remove this... don't think we need it with the LTI 1.3 work... maybe...
        else if (
          res.data.exists === true
          && res.data.migrated == false
        ) {
          commit('simpleDashToggle', { activate: false });
          commit('setBluescreenData', {
            title: 'Bulb Failed to Migrate',
            icon: 'info',
            text: 'Classic lesson failed to migrate to 3.0 environment. Please contact help@playposit.org for support',
            buttons: [
              {
                action: 'help',
              }
            ]
          }, { root: true });
        } else {
          // Close Lti simple dash:
          commit('simpleDashToggle', { activate: false });
          commit('setBluescreenData', {
            title: 'Bulb Not Found',
            icon: 'info',
            text: 'Resource link data not found. Please try and create a new assignment or contact help@playposit.org for support.',
            buttons: [
              {
                action: 'help',
              }
            ]
          }, { root: true });
        }

      } catch (err) {
        dataLayer.errorLog(err.response);
        console.error(err);
      }
    },
    setupAjax ({commit, state}) {
      //add commen ajax headers
      axios.defaults.headers.common['Content-Type'] = 'application/json';
      axios.defaults.headers.common['Accept'] = 'application/json';

      axios.interceptors.response.use(null, (error) => {
        //if response is unauthorized, try to refresh token
        if (error.response && error.response.status === 401) {
          //grab token and user_id
          let old_token = '';
          if(error.config.headers['Authorization']){
            old_token = error.config.headers['Authorization'].replace('Bearer ', '');
          } else {
            old_token = state.urlToken;
          }
          //post to refresh token
          return axios.post(`${state.nodeApiPrefix}/authnew/refreshtoken`, {old_token: old_token}).then((res) => {
            //if success, resend initial request
            return axios.request(error.config);
          }).catch((err) => {
            //if error, log error and send to login page
            dataLayer.axiosLog(err);
            const errMsg = (() => {
              return `${state.phpApiPrefix}/msg?msg=${encodeURI('This session has expired, please login to attempt again.')}&primary_text=login&primary_link=${encodeURI('https://www.playposit.com/login')}`;
            })()
            window.location = errMsg;
          });
        }
        else {
          //if error in interceptor, reject request
          dataLayer.axiosLog(error);
          return Promise.reject(error);
        }
      });
    },
    sendManualLog:({commit, state}, obj) => {
      if(process.env.NODE_ENV === 'production'){
        dataLayer.manualLog(`${obj.category}: ${obj.action}`, 'INFO');
      }
    },
    checkLink: async ({ commit, state, getters, }, obj) => {
      try {
        const {
          contentId,
          renderPath,
        } = obj;
        const {
          nodeApiPrefix,
          LTIdata: {
            section_id: sectionId,
          },
          instructorData: {
            token: userToken,
          }
        } = state;
        const {
          ltiLaunchPath,
        } = getters;
        const result = await axios.get(
          PLAYPOSIT_API_ENDPOINTS.checkLink({
            nodeApiPrefix,
            ltiLaunchPath,
            contentId,
            sectionId,
            renderPath,
            timestamp: moment(),
            lodashInstance: _,
          }),
          {
            headers: {
              'Authorization':`Bearer ${userToken}`,
            },
          }
        );
        const {
          data: checkedLinkData
        } = result;

        commit('setLinkCheck', checkedLinkData); 
      } catch (error) {
        console.error(error);
        dataLayer.errorLog(error.response);
        commit('triggerSnackbar', {
          text:"Checking content association is not working at this time.",
          color: 'red',
          timeout: 6000,
        });
      }
    },
    unlinkBulb: async ({ commit, state, getters, }, obj) => {
      try {
        state.simpleDashLoading = true;
        const {
          bulb_id: bulbId,
          section_id: sectionId,
          content_item_launch: contentItemLaunch,
          render_path: renderPath,
        } = obj;
        const {
          nodeApiPrefix,
          instructorData: {
            token: userToken,
          }
        } = state;
        const {
          ltiLaunchPath,
        } = getters;
        const res = await axios.get(
          PLAYPOSIT_API_ENDPOINTS.unlinkBulb({
            nodeApiPrefix,
            ltiLaunchPath,
            bulbId,
            sectionId,
            contentItemLaunch,
            renderPath,
            timestamp: moment(),
            lodashInstance: _,
          }),
          {
            headers: {
              'Authorization': `Bearer ${userToken}`,
            }
          }
        );
        const {
          data: {
            msg: unlinkStatusMessage, 
          },
        } = res;

        if (unlinkStatusMessage === "success") {
          state.simpleDashLoading = false;
          if (obj.picker) {
            commit('resetLTIPopover', { reset: false, data: {} } );
          } else if (obj.unlinkOther) {
            commit('simpleDashToggle', { activate: false });
            Vue.nextTick(() => {
              commit('simpleDashToggle', {
                activate: true,
                type: 'lti',
                data: obj.unlinkOther,
              });
            });
          } else {
            commit('setDashModal', null);
            commit('simpleDashToggle', { activate: false });
            let obj = {
              title: `"${state.LTIdata.contentName}" Unlinked`,
              msg: 'Your bulb has been successfully unlinked on PlayPosit only',
              submsg: 'To complete the unlinking process, please delete this assignment.',
              secondary: 'Learn More',
              secondarylink: 'unlinkLearnMore',
            };
            Vue.nextTick(() => {
              commit('simpleDashToggle', {
                activate: true,
                type: 'lti',
                data:obj,
              });
            });
          }
        }
      } catch (error) {
        state.simpleDashLoading = false;
        console.error(error);
        dataLayer.errorLog(error.response);
        commit('triggerSnackbar', {
          text: "Bulb unlinking not working at this time.",
          color: 'red',
          timeout: 6000,
        });
      }
    },
    unlinkPlaylist: async ({ commit, getters, state }, obj) => {
      try {
        state.simpleDashLoading = true;
        const {
          sectionId,
          playlistId,
          isContentItemLaunch,
        } = obj;
        const {
          nodeApiPrefix,
          instructorData: {
            token: userToken,
          },
          LTIdata: {
            contentName,
          }
        } = state;
        const {
          ltiLaunchPath,
        } = getters;
        await axios.put(
          PLAYPOSIT_API_ENDPOINTS.unlinkPlaylist({
            nodeApiPrefix,
            ltiLaunchPath,
            playlistId,
            sectionId,
          }),
          {
            isContentItemLaunch,
          },
          {
            headers: {
            'Authorization':`Bearer ${userToken}`,
          }
        });
        commit('simpleDashToggle', { activate: false });
        const greyscreen = {
          title: `"${contentName}" Unlinked`,
          msg: 'Your playlist has been successfully unlinked on PlayPosit only.',
          submsg: 'To complete the unlinking process, please delete this assignment.',
          secondary: 'Learn More',
          secondarylink: 'unlinkLearnMore' // [ ] message for playlinst unlinking?
        }
        Vue.nextTick(() => {
          commit('setDashModal', null);
          commit('simpleDashToggle', {
            activate: true,
            type:'lti',
            data: greyscreen,
          });
        });
      } catch (err) {
        dataLayer.errorLog(err.response);
        commit(
          'triggerSnackbar',
          {
            text:'Playlist unlinking is not working at this time.',
            color: 'red',
            timeout: 6000,
          }
        );
      } finally {
        state.simpleDashLoading = false;
      }
    },
    checkLti1p1ContentAlreadyLinked: async({ commit, state, }, ltiData) => {
      try {
        state.simpleDashLoading = true;
        const {
          instructorData: {
            token: instructorToken,
          },
          nodeApiPrefix,
        } = state;
        const {
          resource_link_id: resourceLinkId,
          context_id: contextId,
          consumerVersion,
        } = ltiData;
        const {
          data: {
            status,
          },
        } = await axios.get(
          PLAYPOSIT_API_ENDPOINTS.checkLti1p1ContentAlreadyLinked({
            nodeApiPrefix,
            contextId,
            resourceLinkId: (state.lti13Launch) ? ltiData?.lti1p1ResourceLinkId : resourceLinkId,
            consumerVersion,
          }),
          {
            headers: {
              'Authorization': `Bearer ${instructorToken}`,
            },
          }
        );
        
        return (status === LTI_CONTENT_LINKED_STATUSES.Linked);
      } catch (error) {
        console.error(error);
        commit(
          'triggerSnackbar',
          {
            text:'Error checking for already linked LTI 1.1 content',
            color: 'red',
            timeout: 6000,
          }
        );
      } finally {
        // We don't want to brick anything, so set this value so the user can still continue regardless of what happens.
        state.simpleDashLoading = false;
      }
    },
    Lti1p1ToLti1p3ContentMigration: async({ commit, dispatch, state, }, ltiData) => {
      try {
        state.simpleDashLoading = true;

        const {
          instructorData: {
            token: instructorToken,
          },
          nodeApiPrefix,
          lti13Launch,
        } = state;

        const {
          consumer_pk: clientId,
          deploymentId,
          isContentItemLaunch,
          section_id: sectionId,
          context_id: contextId,
          resource_link_id: resourceLinkId,
          lti1p1ResourceLinkId,
          consumerVersion,
        } = ltiData;

        if (!lti1p1ResourceLinkId) return;

        const patchPayload = {
          clientId,
          isContentItemLaunch,
          sectionId,
          contextId,
          resourceLinkId,
          lti1p1ResourceLinkId,
          consumerVersion,
        };
        const contentMigrationResult = await axios.patch(
          PLAYPOSIT_API_ENDPOINTS.checkLtiContentMigration({
            nodeApiPrefix,
          }),
          patchPayload,
          {
            headers: {
              'Authorization': `Bearer ${instructorToken}`,
            }
          }
        );

        const {
          data: {
            status: contentMigrationStatus,
            message: contentMigrationMessage,
          }
        } = contentMigrationResult;

        if (contentMigrationStatus !== LTI13_MIGRATION_STATUSES.Success) {
          return {
            status: contentMigrationStatus,
            message: contentMigrationMessage,
          };
        }

        commit('setDashLoading', true);
        // Reload assignment data:
        await dispatch('getContent', {
          resource_link_id: resourceLinkId, 
          consumer_pk: clientId,
          token: instructorToken,
          ...(lti13Launch && { deploymentId, }),
        });
        return {
          status: contentMigrationStatus,
          message: contentMigrationMessage,
        };
      } catch (error) {
        console.error(error);
        commit(
          'triggerSnackbar',
          {
            text:'Error handling the content migration to LTI 1.3',
            color: 'red',
            timeout: 6000,
          }
        );
      } finally {
        // We don't want to brick anything, so set this value so the user can still continue regardless of what happens.
        state.simpleDashLoading = false;
        commit('setLtiContentMigrationFinished', true);
      }
    },
    /**
     * * Verified this with Kathryn, however, we don't actually support our content re-linking flow anymore... haven't for some time.
     */
    relinkAssignment: async ({commit, dispatch, state}, obj) => {
      try {
        state.simpleDashLoading = true;
        const res = await axios.post(`${state.nodeApiPrefix}/ltidash/relink`, obj, {
          headers: {
            'Authorization':`Bearer ${state.instructorData.token}`
          }
        });
        commit('setLTIuser', res.data);
        await dispatch('getLmsData', { // get data stored with PP about user's lms
          consumerPk: res.data.consumer_pk,
          sectionId: res.data.section_id,
        })
        await dispatch('getContent', { // check status of lti assignment and load proper dash
          resource_link_id: res.data.resource_link_id, 
          consumer_pk: res.data.consumer_pk,
          token: state.instructorData.token,
        });
      } catch (err) {
        commit('triggerSnackbar', {text:"Linking bulb did not work at this time.", color: 'red', timeout: 6000});
      } finally {
        state.simpleDashLoading = false;
      }
    },
    setContentLink: async ({ commit, getters, dispatch, state }, obj) => {
      try {

        const {
          contentId,
          renderPath,
          enableGrading,
        } = obj;
        const {
          nodeApiPrefix,
          LTIdata: {
            section_id: sectionId,
            resource_link_id: resourceLinkId,
            consumer_pk: consumerPk,
            deploymentId,
          },
          instructorData: {
            token: userToken,
          },
          lti13Launch,
        } = state;
        const {
          ltiLaunchPath,
        } = getters;
        const groupSetId = obj?.groupSetId;

        const res = await axios.get(
          PLAYPOSIT_API_ENDPOINTS.setContentLink({
            nodeApiPrefix,
            ltiLaunchPath,
            resourceLinkId,
            contentId,
            sectionId,
            consumerPk,
            enableGrading,
            renderPath,
            groupSetId,
            lodashInstance: _,
          }),
          {
            headers: {
              'Authorization': `Bearer ${userToken}`,
            },
          }
        );

        state.dialogShow.dash = false;
        state.popoverToggles.lti = false;

        const {
          data: {
            msg: message,
          },
        } = res;
        const greyScreenData = res?.greyscreen;

        if (message === 'success') {
          commit('setDashLoading', true);
          await dispatch('getContent', { // reload assignment data
            resource_link_id: resourceLinkId, 
            consumer_pk: consumerPk,
            token: userToken,
            ...(lti13Launch && { deploymentId, }),
          });
          commit('triggerSnackbar', {
            text: `${(renderPath === LTI_RENDER_PATHS.Playlist) ? 'Playlist' : 'Bulb'} Linked`,
            color: 'green',
            timeout: 6000,
          });
        }
        else if (message === 'linkedbulb') {
          commit('simpleDashToggle', {
            activate: true,
            type: 'lti',
            data: greyScreenData,
          });
        }
      } catch(error) {
        dataLayer.errorLog(error.response);
        commit('triggerSnackbar', {
          text: "Linking bulb did not work at this time.",
          color: 'red',
          timeout: 6000,
        });
      };
    },
    passbackContent: ({commit, dispatch, state}, obj) => {
      try {
		    let parent = window.parent != null ? window.parent : (window.top != null ? window.top : null);
		    if (parent != null) {
          let postObject = obj.type === 'bulb' ?
            {
              'type': 'playposit__passback_link',
              'bulb_id': obj.bulbId,
              'bulb_name': obj.bulbName,
            }
            :
            {
              'type': 'playposit__passback_link',
              'playlist_id': obj.playlistId,
              'playlist_name': obj.playlistName,
            };
	        parent.postMessage(JSON.stringify(postObject), '*');
	        obj.linked = true;
		    }
		  } catch (e) {
		    // -- catch the error here and log it to GA
		    dataLayer.errorLog({msg: `Unable to send post message. parent ${parent} err: ${JSON.stringify(e)} sessionId: ${this.sessionId}`, location: 'BulbControls: completeBulbPostMessage'});
		    obj.linked = false;
		  }
    },
    getLtiSyncLogs: ({commit, state}, {
      contentId,
      renderPath,
      sectionId,
    } ) => {
      axios.get(`${state.nodeApiPrefix}/ltidash/sync/report?section_id=${sectionId}&content_id=${contentId}&render_path=${renderPath}`, 
        { headers: { 'Authorization':`Bearer ${state.instructorData.token}`}})
      .then(res => {
        commit('setLogData', res.data)
        commit('triggerSnackbar', {text:"Logs updated.", color: 'green', timeout: 6000});
      }).catch((err) => {
        dataLayer.errorLog(err.response);
        console.error(err);
        commit('triggerSnackbar', {text:"Getting LTI sync logs did not work at this time.", color: 'red', timeout: 6000});
      });
    },
    syncLti: async ({commit, dispatch, state, rootGetters, rootState, }, obj) => { // this shit is the worse and I'm scared to touch it...
      if (!state.ltiSync.toggle) {
        state.ltiSync.toggle = true;
        const start_time = moment().tz(state.instructorData.timezone).utc().format();
        const lti13Launch = rootState?.lti13Launch;
        try {
          const path = (() => {
            let studentIds = '';
            const hasSelectedDataToSync = rootGetters['instructors/selectedData'].length > 0;
            if (hasSelectedDataToSync) studentIds = _.map(rootGetters['instructors/selectedData'], 'id');
            if (obj.resourceLinkId) {
              // we use resourceLinkId for the bulbs because we can extract it from the bulbAttempt and don't need to know the specific renderPath/lessonUrl
              const studentIdsQueryParam = (hasSelectedDataToSync) ? `&student_ids=${studentIds.join()}` : '';
              const lti13LaunchQueryParams = (lti13Launch) ? `&lti13Launch=true&issuer=${obj.issuer}` : ''
              return `syncltigrades?resource_link_id=${obj.resourceLinkId}&section_id=${obj.sectionId}&consumer_key=${obj.consumerKey}&start_time=${start_time}${studentIdsQueryParam}${lti13LaunchQueryParams}`;
            }
            else {
              // can be used for any link type, currently only used for playlist because we don't pull in the resourceLinkId during the page load
              const studentIdsQueryParam = (hasSelectedDataToSync) ? `?student_ids=${studentIds.join()}` : '';
              const lti13LaunchQueryParams = (() => {
                if (lti13Launch)  return `${(!studentIdsQueryParam) ? `?` : '&'}lti13Launch=true&issuer=${obj.issuer}`;
                return '';
              })();
              return `sync/section/${obj.sectionId}/content/${obj.contentId}/${obj.renderPath}${studentIdsQueryParam}${lti13LaunchQueryParams}`;
            }
          })();
          const res = await axios.get(`${state.nodeApiPrefix}/ltidash/${path}`, {
            headers: {
              'Authorization':`Bearer ${state.instructorData.token}`
            }
          });
          commit('setLtiSync', res.data.msg);
          commit('triggerSnackbar', {
            text: `Syncing in progress. Click 'Check Sync Status' for more information.`,
            color: 'green',
            timeout: 6000,
          });
          commit('instructors/setSelectedData', []);
          commit('instructors/refreshData');
        } catch (err) {
          state.ltiSync.toggle = false;
          const msg = _.get(err, 'response.data.message', 'Syncing LTI grades did not work at this time.');
          const toastColor = msg === 'Grading is not enabled for this assignment.' ? 'warning' : 'error';
          commit('triggerSnackbar', {
            text: msg,
            color: toastColor,
            timeout: 6000,
          });
        }
      } else {
        commit('triggerSnackbar', {
          text: "Sync already in progress.",
          color: 'red',
          timeout: 6000,
        });
      }
    },
    incrementPlayPositWeVideoAnnouncementViewsForUser: async ({commit, dispatch, state, rootGetters}, obj) => {
      try {
        await axios.patch(
          `${state.nodeApiPrefix}/api/3.1/user/wevideo/announcement/views/increment`, {},
          {
            headers: {
              'Authorization': `Bearer ${obj.userToken}`
            }
          }
        );
      } catch(error) {
        console.error(error);
        dataLayer.errorLog(error);
      }
    },
  },


  getters: {
    dashModal: state => state.dashModal,
    interactionIconMap: state => { // interaction type mapped to material icon name
      return {
        multiple_choice: 'format_list_bulleted',
        check_all_apply: 'playlist_add_check',
        free_response: 'border_color',
        skip_to: 'content_cut',
        short_answer: 'subtitles',
        pause_q: 'bookmark_border',
        iframe_q: 'public',
        file_viewer_q: 'picture_as_pdf',
        poll_q: 'poll',
        discussion_q: 'chat',
        default: 'pets',
        info: 'info',
        secondary_stream: 'ondemand_video',
      }
    },
    interactionTypeMap (state, getters) { // interaction type mapped to text description of interaction type
      return {
        multiple_choice: 'Multiple Choice',
        check_all_apply: 'Check All',
        free_response: 'Free Response',
        skip_to: 'Skip Ahead',
        short_answer: 'Fill in the Blank',
        pause_q: 'Reflective Pause',
        iframe_q: 'Web Embed',
        file_viewer_q: 'PDF File',
        poll_q: 'Polling Survey',
        discussion_q: 'Discussion Forum',
        defaults: 'defaults', // default interactions will not be displayed but here for backup
        info: 'info',
        secondary_stream: 'Secondary Stream',
      }
    },
    dashLoading: state => state.dashLoading, 
    serverURL: state => state.serverURL,
    adminPermission: state => state.adminPermission,
    instructorPermission: state => state.instructorPermission,
    learnerPermission: state => state.learnerPermission,
    primaryAccount: state => state.primaryAccount,
    instructorData: state => state.instructorData,
    learnerData: state => state.learnerData,
    nodeApiPrefix: state => state.nodeApiPrefix,
    playerApiPrefix: state => state.playerApiPrefix,
    designerApiPrefix: state => state.designerApiPrefix,
    phpApiPrefix: state => state.phpApiPrefix,
    username: state => state.username,
    userImg: state => state.userImg,
    activeView: state => state.activeView,
    routerView: state => state.routerView,
    userDataLoaded: state => state.userDataLoaded,
    breadcrumbs: state => state.breadcrumbs,
    breadcrumbPayloads: state => state.breadcrumbPayloads,
    slideOutLarge: state => state.slideOutLarge,
    snackbar: state => state.snackbar,
    slideOut: state => state.slideOut,
    dialogShow: state => state.dialogShow,
    popoverToggles: state => state.popoverToggles,
    studentArchived: state => state.studentArchived,
    stateDataLoaded: state => state.stateDataLoaded,
    classPickerToggle: state => state.classPickerToggle,
    lmb: state => state.lmb,
    bluescreenData: state => state.bluescreenData, // use the new universal Bluescreen Component
    greyscreen: state => state.greyscreen,
    LTIlaunch: state => state.LTIlaunch,
    LTIdata: state => state.LTIdata,
    LMSdata: state => state.LMSdata,
    LTILogs: state => state.LTILogs,
    ltiSync: state => state.ltiSync,
    simpleDash: state => state.simpleDash,
    simpleDashType: state => state.simpleDashType,
    simpleDashData: state => state.simpleDashData,
    simpleDashLoading: state => state.simpleDashLoading,
    popoverDataLoading: state => state.popoverDataLoading,
    LTIclassName: state => state.LTIclassName,
    rubric_id: state => state.rubric_id,
    rubric_lmb_data: state => state.rubric_lmb_data,
    rubric_options: state => state.rubric_options,
    LTIajaxing: state => state.LTIajaxing,
    simpleDashReload: state => state.simpleDashReload,
    instructorType: state => state.instructorType,
    pro: state => state.pro,
    free: state => state.free,
    adminData: state => state.adminData,
    school: state => state.school,
    peerReviewSchool: state => _.get(state.school, 'config.permissions', []).includes('hasPeerReview'),
    hasCanvasApi: state => state.school.canvasApi && !!_.get(state.school, 'canvasApi.domain', null),
    legacy: state => state.legacy, 
    urlToken: state => state.urlToken, 
    searchingForTags: state => state.searchingForTags,
    shareNodeApiPrefix: state => state.shareNodeApiPrefix,
    passbackLinking: state => state.passbackLinking,
    userAgent: state => state.userAgent,
    isProquestUser: (state) => (
      (
        (
          state.primaryAccount === 'Instructor'
          || state.primaryAccount === 'Admin'
        )
        && state.school?.permissionKeys?.includes('isProquestSchool')
      )
      || (
        state.primaryAccount === 'Learner'
        && state.learnerData?.isProquestStudent
      )
    ),
    ltiLaunchPath: (state) => (!state?.lti13Launch) ? 'ltidash' : 'lti13dash',
  },
});

export default store;
